import React, { useEffect } from 'react';
import services from '../services';
import useRouter from '../utils/useRouter';
import { DownloadInformationData } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';
import { noop } from 'lodash';
import initFileDownload from '../components/utils/downloadIFrame';
import { routes } from '../constants';
import { getAmpliDeviceId, getAmpliSessionId } from '../utils/ampli';

const DOWNLOAD_REDIRECT_TIMEOUT = 2000;
const QuickDownloadPage = () => {
  const { match, router: { push } } = useRouter();
  const { params: { mindItemId } } = match;
  const trackingInfo = {
    sessionId: getAmpliSessionId(),
    deviceId: getAmpliDeviceId(),
  };
  
  useEffect(() => {
    if (mindItemId) {
      services.mindItem
        .getDownloadInformation(mindItemId, trackingInfo)
        .then((data: DownloadInformationData) => {
          if (data.canDownload && data.mainDocument?.canDownload && data.mainDocument?.link) {
            initFileDownload(data.mainDocument.link);
            setTimeout(() => push(`/${routes.dashboard.root}`), DOWNLOAD_REDIRECT_TIMEOUT);
          }
        })
        .catch(noop);
    }
  }, [mindItemId]);
  return <></>;
};

export default QuickDownloadPage;
